import { GQLFooterFragment } from '@theprintbar/graphql';
import { ButtonSize, PrimaryLinkButton, SmallArrowIcon } from '@theprintbar/ui';
import { HTMLAttributes } from 'react';

interface CommunityProps extends HTMLAttributes<HTMLDivElement> {
	data: GQLFooterFragment;
}

export function Community({ data, ...props }: CommunityProps) {
	return (
		<div {...props}>
			<p className="font-display font-light text-lg md:text-xl">{data.communityTitle}</p>
			<p className="hidden md:block font-normal text-base my-3">{data.communityText}</p>
			<div className="space-y-2.5 md:mt-10 mt-2.5">
				<p className="font-normal text-sm md:text-base">Email address</p>
				<input className="w-full bg-transparent border-gray-100 border rounded-3xl h-9 outline-none pl-4" />
				<p className="text-xs">
					This site is protected by reCAPTCHA Enterprise and the Google{' '}
					<a href="https://policies.google.com/privacy" className="font-bold underline">
						Privacy Policy
					</a>{' '}
					and{' '}
					<a href="https://policies.google.com/terms" className="font-bold underline ">
						Terms of Service
					</a>{' '}
					apply.
				</p>
				<PrimaryLinkButton
					to={'/'}
					size={ButtonSize.XS}
					className="bg-blue-bright text-blue fill-blue stroke-blue"
					icon={SmallArrowIcon}
				>
					<h5 className="text-xs uppercase">Submit</h5>
				</PrimaryLinkButton>
			</div>
		</div>
	);
}
